import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@resurs/midas-react'
import { getText } from '../../../../../internal/TextLabels'

const ApplicationSignPageDigitalUI = ({
  disabled,
  onNext,
  newPageLoading,
  buttonDivStyle,
}) => (
  <div style={buttonDivStyle}>
    <Button
      id="digital-sign-btn"
      type="primary"
      loading={newPageLoading}
      disabled={disabled}
      autoFocus
      onClick={e => onNext(e)}
    >
      {getText('payApply.sign.button')}
    </Button>
  </div>
)

ApplicationSignPageDigitalUI.propTypes = {
  disabled: PropTypes.bool,
  newPageLoading: PropTypes.bool.isRequired,
  onNext: PropTypes.func.isRequired,
  buttonDivStyle: PropTypes.object,
}

ApplicationSignPageDigitalUI.defaultProps = {
  disabled: false,
  buttonDivStyle: {
    marginTop: '1rem',
    textAlign: 'right',
  },
}

export default ApplicationSignPageDigitalUI
